import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { ColumnFilter, ColumnSort } from "@tanstack/react-table";
import { INITIAL_PAGING, STATUS_INITIAL, STATUS_LOADING, STATUS_SUCCEEDED } from "myParkdUtils/constants";
//import { defaultSortingOnstreetSessions } from "screens/parkingSessions/ParkingSessionsScreen";
import { PagingReactTable, SessionDTOExtended, Status } from "types";

export const defaultSortingOnstreetSessions: ColumnSort[] = [{ id: 'startTime', desc: true }];

export type HistoricalSessionsState = {
    sessions: SessionDTOExtended[];
    paging: PagingReactTable;
    status: Status;
    exportFilters: ColumnFilter[];
    exportSorting: ColumnSort[];
};

export const initialState: HistoricalSessionsState = {
    sessions: [],
    paging: INITIAL_PAGING,
    status: STATUS_INITIAL,
    exportFilters: [],
    exportSorting: defaultSortingOnstreetSessions
};


export const historicalSessionsSlice = createSlice({
    name: 'historicalSessions',
    initialState,
    reducers: {
        getHistoricalSessions(state, action: PayloadAction<{ paging: PagingReactTable, filters?: ColumnFilter[], sorting?: ColumnSort[] }>) {
            state.status = STATUS_LOADING;
            state.sessions = [];
            state.exportFilters = action.payload.filters!;
            state.exportSorting = action.payload.sorting!;
        },
        getHistoricalSessionsCompleted(state, action: PayloadAction<{ sessions: SessionDTOExtended[], totalElements: number, totalPages: number }>) {
            state.status = STATUS_SUCCEEDED;
            state.sessions = action.payload.sessions;
            state.paging.totalElements = action.payload.totalElements;
            state.paging.totalPages = action.payload.totalPages;
        },
        getHistoricalSessionsError(state, action: PayloadAction<{ error: any }>) {
            state.status = {
                ...STATUS_INITIAL,
                error: action.payload.error
            }
        },
        updateSessionNoteCompleted(state, action: PayloadAction<{ updatedSession: SessionDTOExtended }>) {
            state.sessions = updateSessionAfterSessionNoteUpdate(state.sessions, action.payload.updatedSession)
        }
    }
});


export const updateSessionAfterSessionNoteUpdate = (sessions: SessionDTOExtended[], updatedSession: SessionDTOExtended): SessionDTOExtended[] => {
    return sessions.map(session =>
        session.publicId === updatedSession.publicId ? updatedSession : session
    );
}


export const historicalSessionsSliceActions = historicalSessionsSlice.actions;

export default historicalSessionsSlice.reducer;